import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFr = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 17 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_9162_14677",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 17,
		height: 17,
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 8.5,
			cy: 8.5,
			r: 8.5,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_9162_14677)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M-2 1.94062e-07H19V17H-2V1.94062e-07Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M-2 1.94062e-07H4.99985V17H-2V1.94062e-07Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0002 0L19 1.94062e-07V17H12.0002V0Z",
				fill: "#D80027"
			})
		]
	})]
});
export default SvgFr;
